import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@mzic/mzic-environments';
import {
  GetWorkV2Find,
  GetWorkV2FindParams,
  GetWorkUnsynced,
  GetWorkUnsyncedParams,
} from '@mzic/mzic-interfaces';
import { delay, of } from 'rxjs';
import { worksMockData } from './works-mock-data';
import { worksUnsyncedMockData } from './works-unsynced-mock-data';

@Injectable({
  providedIn: 'root',
})
export class WorksService {
  private apiUrl = environment.apiUrl;

  constructor(private readonly _http: HttpClient) {}

  getWorkV2Find(teamId: string, params?: GetWorkV2FindParams) {
    // Simula chamada real com dados mockados e delay de 4s
    const pageNumber = params?.page || 0;
    const pageSize = params?.size || 10;

    // Simula paginação
    const allWorks = [...worksMockData.data.content];
    const totalElements = 15;
    const totalPages = Math.ceil(totalElements / pageSize);

    const start = pageNumber * pageSize;
    const end = start + pageSize;
    const paginatedContent = allWorks.slice(start, end);

    const response: GetWorkV2Find = {
      ...worksMockData,
      data: {
        ...worksMockData.data,
        content: paginatedContent,
        totalPages: totalPages,
        totalElements: totalElements,
        last: pageNumber >= totalPages - 1,
        size: pageSize,
        number: pageNumber,
        numberOfElements: paginatedContent.length,
        first: pageNumber === 0,
        empty: paginatedContent.length === 0,
      },
      page: pageNumber,
      total_pages: totalPages,
      per_page: pageSize,
      total_items: totalElements,
    } as GetWorkV2Find;

    // Delay de 4 segundos para simular loading
    return of(response).pipe(delay(2000));

    // Código real comentado para quando a API estiver disponível
    // if (params?.page) {
    //   params.page--;
    // }
    // const headers = new HttpHeaders().append('TEAM-ID', teamId);
    // return this._http.get<GetWorkV2Find>(
    //   `${this.apiUrl}/api/distribution/work/v2/find`,
    //   {
    //     headers,
    //     ...httpParams(params),
    //   },
    // );
  }

  getWorkUnsynced(teamId: string, params?: GetWorkUnsyncedParams) {
    // Simula chamada real com dados mockados e delay de 2s
    const pageNumber = params?.page || 0;
    const pageSize = params?.size || 10;

    // Simula paginação
    const allWorks = [...worksUnsyncedMockData.data.content];
    const totalElements = 5;
    const totalPages = Math.ceil(totalElements / pageSize);

    const start = pageNumber * pageSize;
    const end = start + pageSize;
    const paginatedContent = allWorks.slice(start, end);

    const response: GetWorkUnsynced = {
      ...worksUnsyncedMockData,
      data: {
        ...worksUnsyncedMockData.data,
        content: paginatedContent,
        totalPages: totalPages,
        totalElements: totalElements,
        last: pageNumber >= totalPages - 1,
        size: pageSize,
        number: pageNumber,
        numberOfElements: paginatedContent.length,
        first: pageNumber === 0,
        empty: paginatedContent.length === 0,
      },
      page: pageNumber,
      total_pages: totalPages,
      per_page: pageSize,
      total_items: totalElements,
    } as GetWorkUnsynced;

    // Delay de 2 segundos para simular loading
    return of(response).pipe(delay(2000));

    // Código real comentado para quando a API estiver disponível
    // if (params?.page) {
    //   params.page--;
    // }
    // const headers = new HttpHeaders().append('TEAM-ID', teamId);
    // return this._http.get<GetWorkUnsynced>(
    //   `${this.apiUrl}/api/distribution/work/unsynced`,
    //   {
    //     headers,
    //     ...httpParams(params),
    //   },
    // );
  }

  syncCatalogueWorks(teamId: string, workIds: number[]) {
    // Simula chamada real com dados mockados e delay de 8s
    // Retorna true para indicar sucesso
    return of({ success: true }).pipe(delay(8000));

    // Código real comentado para quando a API estiver disponível
    // const headers = new HttpHeaders().append('TEAM-ID', teamId);
    // return this._http.post<{ success: boolean }>(
    //   `${this.apiUrl}/api/distribution/work/sync`,
    //   { workIds },
    //   { headers },
    // );
  }
}
